"use strict";

require("core-js/modules/es6.array.filter.js");
var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CONTACTS_TO_SHOW = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactIntl = require("react-intl");
var _he = _interopRequireDefault(require("he"));
var _button = _interopRequireDefault(require("@gravity/button"));
var _config = require("@nucleo/config");
var _jsxFileName = "/codebuild/output/src3938275692/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/functional/TsHeader/lib/UserInfo.js",
  _templateObject,
  _templateObject2,
  _this = void 0;
function cov_1ejpmp92jy() {
  var path = "/codebuild/output/src3938275692/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/functional/TsHeader/lib/UserInfo.js";
  var hash = "a3591141c5885fcbe457d82fc64dbdb16eed3f2e";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3938275692/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/functional/TsHeader/lib/UserInfo.js",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 16
        },
        end: {
          line: 22,
          column: 1
        }
      },
      "1": {
        start: {
          line: 15,
          column: 20
        },
        end: {
          line: 15,
          column: 79
        }
      },
      "2": {
        start: {
          line: 20,
          column: 22
        },
        end: {
          line: 20,
          column: 91
        }
      },
      "3": {
        start: {
          line: 24,
          column: 17
        },
        end: {
          line: 35,
          column: 1
        }
      },
      "4": {
        start: {
          line: 27,
          column: 20
        },
        end: {
          line: 27,
          column: 79
        }
      },
      "5": {
        start: {
          line: 33,
          column: 22
        },
        end: {
          line: 33,
          column: 91
        }
      },
      "6": {
        start: {
          line: 37,
          column: 23
        },
        end: {
          line: 37,
          column: 38
        }
      },
      "7": {
        start: {
          line: 39,
          column: 32
        },
        end: {
          line: 43,
          column: 1
        }
      },
      "8": {
        start: {
          line: 45,
          column: 33
        },
        end: {
          line: 50,
          column: 1
        }
      },
      "9": {
        start: {
          line: 46,
          column: 2
        },
        end: {
          line: 48,
          column: 3
        }
      },
      "10": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 76
        }
      },
      "11": {
        start: {
          line: 49,
          column: 2
        },
        end: {
          line: 49,
          column: 14
        }
      },
      "12": {
        start: {
          line: 52,
          column: 17
        },
        end: {
          line: 98,
          column: 1
        }
      },
      "13": {
        start: {
          line: 53,
          column: 84
        },
        end: {
          line: 53,
          column: 89
        }
      },
      "14": {
        start: {
          line: 54,
          column: 18
        },
        end: {
          line: 54,
          column: 59
        }
      },
      "15": {
        start: {
          line: 56,
          column: 2
        },
        end: {
          line: 58,
          column: 3
        }
      },
      "16": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 57,
          column: 16
        }
      },
      "17": {
        start: {
          line: 60,
          column: 20
        },
        end: {
          line: 60,
          column: 22
        }
      },
      "18": {
        start: {
          line: 61,
          column: 21
        },
        end: {
          line: 61,
          column: 26
        }
      },
      "19": {
        start: {
          line: 63,
          column: 2
        },
        end: {
          line: 84,
          column: 3
        }
      },
      "20": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 64,
          column: 24
        }
      },
      "21": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 83,
          column: 5
        }
      },
      "22": {
        start: {
          line: 69,
          column: 8
        },
        end: {
          line: 69,
          column: 45
        }
      },
      "23": {
        start: {
          line: 70,
          column: 8
        },
        end: {
          line: 70,
          column: 28
        }
      },
      "24": {
        start: {
          line: 71,
          column: 8
        },
        end: {
          line: 71,
          column: 14
        }
      },
      "25": {
        start: {
          line: 73,
          column: 8
        },
        end: {
          line: 73,
          column: 79
        }
      },
      "26": {
        start: {
          line: 74,
          column: 8
        },
        end: {
          line: 77,
          column: 41
        }
      },
      "27": {
        start: {
          line: 78,
          column: 8
        },
        end: {
          line: 78,
          column: 14
        }
      },
      "28": {
        start: {
          line: 81,
          column: 8
        },
        end: {
          line: 81,
          column: 28
        }
      },
      "29": {
        start: {
          line: 82,
          column: 8
        },
        end: {
          line: 82,
          column: 14
        }
      },
      "30": {
        start: {
          line: 86,
          column: 2
        },
        end: {
          line: 97,
          column: 4
        }
      },
      "31": {
        start: {
          line: 100,
          column: 0
        },
        end: {
          line: 103,
          column: 2
        }
      },
      "32": {
        start: {
          line: 105,
          column: 0
        },
        end: {
          line: 108,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 15,
            column: 11
          },
          end: {
            line: 15,
            column: 12
          }
        },
        loc: {
          start: {
            line: 15,
            column: 20
          },
          end: {
            line: 15,
            column: 79
          }
        },
        line: 15
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 20,
            column: 13
          },
          end: {
            line: 20,
            column: 14
          }
        },
        loc: {
          start: {
            line: 20,
            column: 22
          },
          end: {
            line: 20,
            column: 91
          }
        },
        line: 20
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 27,
            column: 11
          },
          end: {
            line: 27,
            column: 12
          }
        },
        loc: {
          start: {
            line: 27,
            column: 20
          },
          end: {
            line: 27,
            column: 79
          }
        },
        line: 27
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 33,
            column: 13
          },
          end: {
            line: 33,
            column: 14
          }
        },
        loc: {
          start: {
            line: 33,
            column: 22
          },
          end: {
            line: 33,
            column: 91
          }
        },
        line: 33
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 45,
            column: 33
          },
          end: {
            line: 45,
            column: 34
          }
        },
        loc: {
          start: {
            line: 45,
            column: 54
          },
          end: {
            line: 50,
            column: 1
          }
        },
        line: 45
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 52,
            column: 17
          },
          end: {
            line: 52,
            column: 18
          }
        },
        loc: {
          start: {
            line: 52,
            column: 26
          },
          end: {
            line: 98,
            column: 1
          }
        },
        line: 52
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 15,
            column: 20
          },
          end: {
            line: 15,
            column: 79
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 15,
            column: 20
          },
          end: {
            line: 15,
            column: 50
          }
        }, {
          start: {
            line: 15,
            column: 54
          },
          end: {
            line: 15,
            column: 79
          }
        }],
        line: 15
      },
      "1": {
        loc: {
          start: {
            line: 20,
            column: 22
          },
          end: {
            line: 20,
            column: 91
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 22
          },
          end: {
            line: 20,
            column: 52
          }
        }, {
          start: {
            line: 20,
            column: 56
          },
          end: {
            line: 20,
            column: 81
          }
        }, {
          start: {
            line: 20,
            column: 85
          },
          end: {
            line: 20,
            column: 91
          }
        }],
        line: 20
      },
      "2": {
        loc: {
          start: {
            line: 27,
            column: 20
          },
          end: {
            line: 27,
            column: 79
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 27,
            column: 20
          },
          end: {
            line: 27,
            column: 50
          }
        }, {
          start: {
            line: 27,
            column: 54
          },
          end: {
            line: 27,
            column: 79
          }
        }],
        line: 27
      },
      "3": {
        loc: {
          start: {
            line: 33,
            column: 22
          },
          end: {
            line: 33,
            column: 91
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 33,
            column: 22
          },
          end: {
            line: 33,
            column: 52
          }
        }, {
          start: {
            line: 33,
            column: 56
          },
          end: {
            line: 33,
            column: 81
          }
        }, {
          start: {
            line: 33,
            column: 85
          },
          end: {
            line: 33,
            column: 91
          }
        }],
        line: 33
      },
      "4": {
        loc: {
          start: {
            line: 46,
            column: 2
          },
          end: {
            line: 48,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 46,
            column: 2
          },
          end: {
            line: 48,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 46
      },
      "5": {
        loc: {
          start: {
            line: 46,
            column: 6
          },
          end: {
            line: 46,
            column: 23
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 46,
            column: 6
          },
          end: {
            line: 46,
            column: 10
          }
        }, {
          start: {
            line: 46,
            column: 14
          },
          end: {
            line: 46,
            column: 23
          }
        }],
        line: 46
      },
      "6": {
        loc: {
          start: {
            line: 54,
            column: 18
          },
          end: {
            line: 54,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 54,
            column: 18
          },
          end: {
            line: 54,
            column: 23
          }
        }, {
          start: {
            line: 54,
            column: 27
          },
          end: {
            line: 54,
            column: 59
          }
        }],
        line: 54
      },
      "7": {
        loc: {
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 58,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 58,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 56
      },
      "8": {
        loc: {
          start: {
            line: 63,
            column: 2
          },
          end: {
            line: 84,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 63,
            column: 2
          },
          end: {
            line: 84,
            column: 3
          }
        }, {
          start: {
            line: 65,
            column: 9
          },
          end: {
            line: 84,
            column: 3
          }
        }],
        line: 63
      },
      "9": {
        loc: {
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 83,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 68,
            column: 6
          },
          end: {
            line: 71,
            column: 14
          }
        }, {
          start: {
            line: 72,
            column: 6
          },
          end: {
            line: 78,
            column: 14
          }
        }, {
          start: {
            line: 79,
            column: 6
          },
          end: {
            line: 79,
            column: 34
          }
        }, {
          start: {
            line: 80,
            column: 6
          },
          end: {
            line: 82,
            column: 14
          }
        }],
        line: 67
      },
      "10": {
        loc: {
          start: {
            line: 69,
            column: 22
          },
          end: {
            line: 69,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 69,
            column: 22
          },
          end: {
            line: 69,
            column: 35
          }
        }, {
          start: {
            line: 69,
            column: 39
          },
          end: {
            line: 69,
            column: 44
          }
        }],
        line: 69
      },
      "11": {
        loc: {
          start: {
            line: 73,
            column: 26
          },
          end: {
            line: 73,
            column: 78
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 73,
            column: 34
          },
          end: {
            line: 73,
            column: 71
          }
        }, {
          start: {
            line: 73,
            column: 74
          },
          end: {
            line: 73,
            column: 78
          }
        }],
        line: 73
      },
      "12": {
        loc: {
          start: {
            line: 75,
            column: 10
          },
          end: {
            line: 77,
            column: 40
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 76,
            column: 14
          },
          end: {
            line: 76,
            column: 59
          }
        }, {
          start: {
            line: 77,
            column: 14
          },
          end: {
            line: 77,
            column: 40
          }
        }],
        line: 75
      },
      "13": {
        loc: {
          start: {
            line: 94,
            column: 7
          },
          end: {
            line: 95,
            column: 94
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 94,
            column: 7
          },
          end: {
            line: 94,
            column: 19
          }
        }, {
          start: {
            line: 95,
            column: 8
          },
          end: {
            line: 95,
            column: 21
          }
        }, {
          start: {
            line: 95,
            column: 25
          },
          end: {
            line: 95,
            column: 94
          }
        }],
        line: 94
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0],
      "2": [0, 0],
      "3": [0, 0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0, 0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a3591141c5885fcbe457d82fc64dbdb16eed3f2e"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1ejpmp92jy = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1ejpmp92jy();
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var Wrapper = (cov_1ejpmp92jy().s[0]++, (0, _styledComponents.default)(_button.default).attrs({
  className: 'stx-UserInfo'
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  line-height: 1;\n  text-align: right;\n  font-size: 14px;\n  color: ", ";\n\n  &:hover,\n  &:active,\n  &:focus {\n    color: ", ";\n  }\n"])), function (props) {
  cov_1ejpmp92jy().f[0]++;
  cov_1ejpmp92jy().s[1]++;
  return (cov_1ejpmp92jy().b[0][0]++, props.theme.tsHeader.textColor) || (cov_1ejpmp92jy().b[0][1]++, props.theme.content.color);
}, function (props) {
  cov_1ejpmp92jy().f[1]++;
  cov_1ejpmp92jy().s[2]++;
  return (cov_1ejpmp92jy().b[1][0]++, props.theme.tsHeader.textColor) || (cov_1ejpmp92jy().b[1][1]++, props.theme.content.color) || (cov_1ejpmp92jy().b[1][2]++, '#fff');
}));
var Subtitle = (cov_1ejpmp92jy().s[3]++, _styledComponents.default.span.attrs({
  className: 'stx-Subtitle'
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  padding: 0.25rem 0 0.25rem 0.25rem;\n\n  &:hover,\n  &:active,\n  &:focus {\n    color: ", ";\n  }\n"])), function (props) {
  cov_1ejpmp92jy().f[2]++;
  cov_1ejpmp92jy().s[4]++;
  return (cov_1ejpmp92jy().b[2][0]++, props.theme.tsHeader.textColor) || (cov_1ejpmp92jy().b[2][1]++, props.theme.content.color);
}, function (props) {
  cov_1ejpmp92jy().f[3]++;
  cov_1ejpmp92jy().s[5]++;
  return (cov_1ejpmp92jy().b[3][0]++, props.theme.tsHeader.textColor) || (cov_1ejpmp92jy().b[3][1]++, props.theme.content.color) || (cov_1ejpmp92jy().b[3][2]++, '#fff');
}));
var MOBILE_MENU_ID = (cov_1ejpmp92jy().s[6]++, 'ts-MobileMenu');
var CONTACTS_TO_SHOW = exports.CONTACTS_TO_SHOW = (cov_1ejpmp92jy().s[7]++, {
  AGENCY: 'AGENCY',
  NAME: 'NAME',
  EMAIL: 'EMAIL'
});
cov_1ejpmp92jy().s[8]++;
var buildTranslatedUserTitle = function buildTranslatedUserTitle(intl, titleEnum) {
  cov_1ejpmp92jy().f[4]++;
  cov_1ejpmp92jy().s[9]++;
  if ((cov_1ejpmp92jy().b[5][0]++, intl) && (cov_1ejpmp92jy().b[5][1]++, titleEnum)) {
    cov_1ejpmp92jy().b[4][0]++;
    cov_1ejpmp92jy().s[10]++;
    return intl.formatMessage({
      id: "gravity.contact.title.".concat(titleEnum)
    });
  } else {
    cov_1ejpmp92jy().b[4][1]++;
  }
  cov_1ejpmp92jy().s[11]++;
  return null;
};
cov_1ejpmp92jy().s[12]++;
var UserInfo = function UserInfo(props) {
  cov_1ejpmp92jy().f[5]++;
  var _ref = (cov_1ejpmp92jy().s[13]++, props),
    contactToShow = _ref.contactToShow,
    structureName = _ref.structureName,
    email = _ref.email,
    firstName = _ref.firstName,
    lastName = _ref.lastName,
    title = _ref.title,
    intl = _ref.intl;
  var isGuest = (cov_1ejpmp92jy().s[14]++, (cov_1ejpmp92jy().b[6][0]++, email) && (cov_1ejpmp92jy().b[6][1]++, email.toUpperCase() === lastName));
  cov_1ejpmp92jy().s[15]++;
  if (!contactToShow) {
    cov_1ejpmp92jy().b[7][0]++;
    cov_1ejpmp92jy().s[16]++;
    return null;
  } else {
    cov_1ejpmp92jy().b[7][1]++;
  }
  var displayName = (cov_1ejpmp92jy().s[17]++, '');
  var showSubtitle = (cov_1ejpmp92jy().s[18]++, false);
  cov_1ejpmp92jy().s[19]++;
  if (isGuest) {
    cov_1ejpmp92jy().b[8][0]++;
    cov_1ejpmp92jy().s[20]++;
    displayName = email;
  } else {
    cov_1ejpmp92jy().b[8][1]++;
    var translatedTitle;
    cov_1ejpmp92jy().s[21]++;
    switch (contactToShow.toUpperCase()) {
      case CONTACTS_TO_SHOW.AGENCY:
        cov_1ejpmp92jy().b[9][0]++;
        cov_1ejpmp92jy().s[22]++;
        displayName = (cov_1ejpmp92jy().b[10][0]++, structureName) || (cov_1ejpmp92jy().b[10][1]++, email);
        cov_1ejpmp92jy().s[23]++;
        showSubtitle = true;
        cov_1ejpmp92jy().s[24]++;
        break;
      case CONTACTS_TO_SHOW.NAME:
        cov_1ejpmp92jy().b[9][1]++;
        cov_1ejpmp92jy().s[25]++;
        translatedTitle = title ? (cov_1ejpmp92jy().b[11][0]++, buildTranslatedUserTitle(intl, title)) : (cov_1ejpmp92jy().b[11][1]++, null);
        cov_1ejpmp92jy().s[26]++;
        displayName = translatedTitle !== null ? (cov_1ejpmp92jy().b[12][0]++, "".concat(translatedTitle, " ").concat(firstName, " ").concat(lastName)) : (cov_1ejpmp92jy().b[12][1]++, "".concat(firstName, " ").concat(lastName));
        cov_1ejpmp92jy().s[27]++;
        break;
      case CONTACTS_TO_SHOW.EMAIL:
        cov_1ejpmp92jy().b[9][2]++;
      default:
        cov_1ejpmp92jy().b[9][3]++;
        cov_1ejpmp92jy().s[28]++;
        displayName = email;
        cov_1ejpmp92jy().s[29]++;
        break;
    }
  }
  cov_1ejpmp92jy().s[30]++;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    small: true,
    flat: true,
    onClick: props.onClick,
    "aria-expanded": props.isMobileMenuOpen,
    "aria-controls": MOBILE_MENU_ID,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 87,
      columnNumber: 5
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 93,
      columnNumber: 7
    }
  }, _he.default.decode(displayName)), (cov_1ejpmp92jy().b[13][0]++, showSubtitle) && (cov_1ejpmp92jy().b[13][1]++, structureName) && (cov_1ejpmp92jy().b[13][2]++, /*#__PURE__*/_react.default.createElement(Subtitle, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 95,
      columnNumber: 26
    }
  }, _he.default.decode("".concat(title, " ").concat(firstName, " ").concat(lastName)))));
};
cov_1ejpmp92jy().s[31]++;
UserInfo.propTypes = _objectSpread(_objectSpread({}, _config.UserContactType), {}, {
  intl: _reactIntl.intlShape.isRequired
});
cov_1ejpmp92jy().s[32]++;
UserInfo.defaultProps = {
  structureName: '',
  contactToShow: CONTACTS_TO_SHOW.NAME
};
var _default = exports.default = (0, _reactIntl.injectIntl)(UserInfo);